import {
  REQUEST_INVENTORY_BATCHES,
  FETCH_INVENTORY_BATCHES_SUCCESS,
  FETCH_INVENTORY_BATCHES_FAILURE,
  REQUEST_PRODUCT_INVENTORY_BATCHES,
  FETCH_PRODUCT_INVENTORY_BATCHES_SUCCESS,
  FETCH_PRODUCT_INVENTORY_BATCHES_FAILURE
} from '../actions/type'

const INITIAL_STATE = {
  all: [],
  isLoading: false,
  error: null,
  productInventory: [],
  productIsLoading: false,
  productError: null,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    // Favorites action handlers
    case REQUEST_INVENTORY_BATCHES:
      return { ...state, error: null, isLoading: true };
    case FETCH_INVENTORY_BATCHES_SUCCESS:
      return { ...state, all: action.payload.data, error: null, isLoading: false };
    case FETCH_INVENTORY_BATCHES_FAILURE:
      const error = action.payload || { message: action.payload.message };
      return { ...state, all: [], error: error, isLoading: false };
    case REQUEST_PRODUCT_INVENTORY_BATCHES:
      return { ...state, productError: null, productIsLoading: true };
    case FETCH_PRODUCT_INVENTORY_BATCHES_SUCCESS:
      return { ...state, productInventory: action.payload.data, productError: null, productIsLoading: false };
    case FETCH_PRODUCT_INVENTORY_BATCHES_FAILURE:
      const productError = action.payload || { message: action.payload.message };
      return { ...state, productInventory: [], productError: productError, productIsLoading: false };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/wholesaleModal_reducer.jsx